export default "__VITE_ASSET__f_u82wmj__"